var exports = {
  "base": "x127c5a35--8ca1b7--base",
  "small": "x127c5a35--8ca1b7--small",
  "h1": "x127c5a35--8ca1b7--h1",
  "h2": "x127c5a35--8ca1b7--h2",
  "h3": "x127c5a35--8ca1b7--h3",
  "bold": "x127c5a35--8ca1b7--bold",
  "black": "x127c5a35--8ca1b7--black",
  "orange": "x127c5a35--8ca1b7--orange",
  "blue": "x127c5a35--8ca1b7--blue",
  "gray": "x127c5a35--8ca1b7--gray",
  "white": "x127c5a35--8ca1b7--white",
};

module.exports = exports;
